(() => {
  const hasBackgroundImage = (element) => {
    if (!(element instanceof Element)) return false;
    return /url\(/i.test(getComputedStyle(element).backgroundImage);
  };

  document.addEventListener('contextmenu', (event) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    const isImageTarget = path.some((node) => {
      if (!(node instanceof Element)) return false;
      return node.matches('img, picture') || hasBackgroundImage(node);
    });

    if (isImageTarget) event.preventDefault();
  });

  document.addEventListener('dragstart', (event) => {
    const target = event.target;
    if (target instanceof Element && target.closest('img, picture')) {
      event.preventDefault();
    }
  });
})();
